import { render, staticRenderFns } from "./spokesman.vue?vue&type=template&id=1538e10a&scoped=true"
import script from "./spokesman.vue?vue&type=script&lang=js"
export * from "./spokesman.vue?vue&type=script&lang=js"
import style0 from "./spokesman.vue?vue&type=style&index=0&id=1538e10a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1538e10a",
  null
  
)

export default component.exports